if (!customElements.get('sticky-media')) {
  class StickyMedia extends HTMLElement {
    mediaQuery = window.matchMedia('screen and (min-width: 990px)');
    selectors = {
      id: '',
      section: '[data-main-product]',
      innerWrapper: '[data-product-media]'
    };
    headerHeight = 82;
    mainProductTopPadding = 16;

    constructor() {
      super();
    }

    handleResize() {
      if (this.mediaQuery.matches) {
        this.init();
      } else {
        this.destroy();
      }
    }

    init() {
      this.sidebar = new StickySidebar(this.selectors.id, {
        containerSelector: this.selectors.section,
        innerWrapperSelector: this.selectors.innerWrapper,
        topSpacing: this.headerHeight + this.mainProductTopPadding,
      });
      this.classList.remove('is-disabled');
    }

    destroy() {
      this.sidebar.destroy();
      this.classList.add('is-disabled');
    }

    connectedCallback() { 
      this.selectors.id = `#${this.getAttribute('id')}`;

      if (this.mediaQuery.matches) this.init();

      this.mediaQuery.addEventListener(
        'change',
        this.handleResize.bind(this)
      );
    }
  }
  customElements.define('sticky-media', StickyMedia);
}
